module.exports = __webpack_public_path__ + "img/iconComplementos.05d0c129.svg";